/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { DocumentiClonaForm } from '../model/models';
import { DocumentiOrdineForm } from '../model/models';
import { DocumentoAdminDTO } from '../model/models';
import { DocumentoBozzaForm } from '../model/models';
import { DocumentoCorrezioneForm } from '../model/models';
import { DocumentoCorrezioneStoricoDTO } from '../model/models';
import { DocumentoVersionForm } from '../model/models';
import { DocumentoVersioneDettaglioDTO } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface ClonaDocumentiComuneBackofficeRequestParams {
    idComune: string;
    documentiClonaForm: DocumentiClonaForm;
}

export interface CorreggiDocumentoComuneVersioneBackofficeRequestParams {
    idComune: string;
    idDocumento: string;
    numero: number;
    documentoCorrezioneForm: DocumentoCorrezioneForm;
}

export interface CreaDocumentoComuneBackofficeRequestParams {
    idComune: string;
    documentoBozzaForm: DocumentoBozzaForm;
}

export interface EliminaDocumentoComuneBackofficeRequestParams {
    idComune: string;
    idDocumento: string;
    version: number;
}

export interface EliminaDocumentoComuneBozzaBackofficeRequestParams {
    idComune: string;
    idDocumento: string;
    version: number;
}

export interface GetDocumentoComuneCorrezioniBackofficeRequestParams {
    idComune: string;
    idDocumento: string;
    numero: number;
}

export interface GetDocumentoComuneVersioneBackofficeRequestParams {
    idComune: string;
    idDocumento: string;
    numero: number;
}

export interface ListDocumentiComuneBackofficeRequestParams {
    idComune: string;
}

export interface PubblicaDocumentoComuneBozzaBackofficeRequestParams {
    idComune: string;
    idDocumento: string;
    documentoVersionForm: DocumentoVersionForm;
}

export interface RiordinaDocumentiComuneBackofficeRequestParams {
    idComune: string;
    documentiOrdineForm: DocumentiOrdineForm;
}

export interface RipristinaDocumentoComuneBackofficeRequestParams {
    idComune: string;
    idDocumento: string;
    documentoVersionForm: DocumentoVersionForm;
}

export interface RitiraDocumentoComuneBackofficeRequestParams {
    idComune: string;
    idDocumento: string;
    documentoVersionForm: DocumentoVersionForm;
}

export interface SalvaDocumentoComuneBozzaBackofficeRequestParams {
    idComune: string;
    idDocumento: string;
    documentoBozzaForm: DocumentoBozzaForm;
}


export interface DocumentiDelComuneGestioneServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Clona i documenti attivi di un altro comune come bozze (SUPERADMIN).
     * Per ogni documento attivo della sorgente nasce nel comune un documento nuovo con una sola bozza (copia della versione corrente, o della bozza se non pubblicato). Niente viene pubblicato e il destinatario esistente non si tocca.
     * @endpoint post /api/v1/gestione/comuni/{id_comune}/documenti/clona
* @param requestParameters
     */
    clonaDocumentiComuneBackoffice(requestParameters: ClonaDocumentiComuneBackofficeRequestParams, extraHttpRequestParams?: any): Observable<Array<DocumentoAdminDTO>>;

    /**
     * Corregge i refusi della versione corrente di un documento (SUPERADMIN).
     * Solo testi (titoli, testi, testo delle spunte): numero e spunte invariati, nessuna riaccettazione. Il contenuto precedente resta nello storico delle correzioni.
     * @endpoint put /api/v1/gestione/comuni/{id_comune}/documenti/{id_documento}/versioni/{numero}
* @param requestParameters
     */
    correggiDocumentoComuneVersioneBackoffice(requestParameters: CorreggiDocumentoComuneVersioneBackofficeRequestParams, extraHttpRequestParams?: any): Observable<DocumentoVersioneDettaglioDTO>;

    /**
     * Crea un documento con la sua prima bozza (SUPERADMIN).
     * Il documento nasce ATTIVO, in coda all\&#39;ordine, con una sola bozza; i cittadini non vedono nulla finche\&#39; non e\&#39; pubblicata.
     * @endpoint post /api/v1/gestione/comuni/{id_comune}/documenti
* @param requestParameters
     */
    creaDocumentoComuneBackoffice(requestParameters: CreaDocumentoComuneBackofficeRequestParams, extraHttpRequestParams?: any): Observable<DocumentoAdminDTO>;

    /**
     * Elimina un documento mai pubblicato (SUPERADMIN).
     * Richiede il query param obbligatorio version &#x3D; version del documento.
     * @endpoint delete /api/v1/gestione/comuni/{id_comune}/documenti/{id_documento}
* @param requestParameters
     */
    eliminaDocumentoComuneBackoffice(requestParameters: EliminaDocumentoComuneBackofficeRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Elimina la bozza di un documento (SUPERADMIN).
     * Se il documento non ha versioni pubblicate viene eliminato anche il documento. Richiede il query param obbligatorio version &#x3D; version della bozza.
     * @endpoint delete /api/v1/gestione/comuni/{id_comune}/documenti/{id_documento}/bozza
* @param requestParameters
     */
    eliminaDocumentoComuneBozzaBackoffice(requestParameters: EliminaDocumentoComuneBozzaBackofficeRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Storico delle correzioni di una versione (SUPERADMIN, OP_COMUNE).
     * Dalla piu\&#39; recente: quando, chi e il contenuto prima della correzione.
     * @endpoint get /api/v1/gestione/comuni/{id_comune}/documenti/{id_documento}/versioni/{numero}/correzioni
* @param requestParameters
     */
    getDocumentoComuneCorrezioniBackoffice(requestParameters: GetDocumentoComuneCorrezioniBackofficeRequestParams, extraHttpRequestParams?: any): Observable<Array<DocumentoCorrezioneStoricoDTO>>;

    /**
     * Una versione pubblicata di un documento, con i testi (SUPERADMIN, OP_COMUNE).
     * 
     * @endpoint get /api/v1/gestione/comuni/{id_comune}/documenti/{id_documento}/versioni/{numero}
* @param requestParameters
     */
    getDocumentoComuneVersioneBackoffice(requestParameters: GetDocumentoComuneVersioneBackofficeRequestParams, extraHttpRequestParams?: any): Observable<DocumentoVersioneDettaglioDTO>;

    /**
     * Documenti di consenso del comune (SUPERADMIN, OP_COMUNE).
     * Per ordine, ritirati inclusi, con versione corrente e storico delle versioni pubblicate. La bozza e\&#39; sempre nulla per l\&#39;OP_COMUNE, che non vede i documenti mai pubblicati.
     * @endpoint get /api/v1/gestione/comuni/{id_comune}/documenti
* @param requestParameters
     */
    listDocumentiComuneBackoffice(requestParameters: ListDocumentiComuneBackofficeRequestParams, extraHttpRequestParams?: any): Observable<Array<DocumentoAdminDTO>>;

    /**
     * Pubblica la bozza di un documento (SUPERADMIN).
     * Numero di versione &#x3D; ultimo pubblicato + 1; richiede almeno una spunta. Richiede la version della bozza.
     * @endpoint post /api/v1/gestione/comuni/{id_comune}/documenti/{id_documento}/bozza/pubblica
* @param requestParameters
     */
    pubblicaDocumentoComuneBozzaBackoffice(requestParameters: PubblicaDocumentoComuneBozzaBackofficeRequestParams, extraHttpRequestParams?: any): Observable<DocumentoAdminDTO>;

    /**
     * Imposta l\&#39;ordine dei documenti del comune (SUPERADMIN).
     * La lista deve essere una permutazione esatta di tutti i documenti del comune.
     * @endpoint put /api/v1/gestione/comuni/{id_comune}/documenti/ordine
* @param requestParameters
     */
    riordinaDocumentiComuneBackoffice(requestParameters: RiordinaDocumentiComuneBackofficeRequestParams, extraHttpRequestParams?: any): Observable<Array<DocumentoAdminDTO>>;

    /**
     * Ripristina un documento ritirato (SUPERADMIN).
     * Chi ha accettato la versione corrente non deve riaccettare.
     * @endpoint post /api/v1/gestione/comuni/{id_comune}/documenti/{id_documento}/ripristina
* @param requestParameters
     */
    ripristinaDocumentoComuneBackoffice(requestParameters: RipristinaDocumentoComuneBackofficeRequestParams, extraHttpRequestParams?: any): Observable<DocumentoAdminDTO>;

    /**
     * Ritira un documento (SUPERADMIN).
     * Esce dalla modale dei cittadini; lo storico delle accettazioni resta intatto.
     * @endpoint post /api/v1/gestione/comuni/{id_comune}/documenti/{id_documento}/ritira
* @param requestParameters
     */
    ritiraDocumentoComuneBackoffice(requestParameters: RitiraDocumentoComuneBackofficeRequestParams, extraHttpRequestParams?: any): Observable<DocumentoAdminDTO>;

    /**
     * Crea o aggiorna la bozza di un documento (SUPERADMIN).
     * version nulla e nessuna bozza &#x3D; crea la bozza della versione successiva; valorizzata &#x3D; aggiorna con optimistic lock. Le spunte sono sostituite in blocco.
     * @endpoint put /api/v1/gestione/comuni/{id_comune}/documenti/{id_documento}/bozza
* @param requestParameters
     */
    salvaDocumentoComuneBozzaBackoffice(requestParameters: SalvaDocumentoComuneBozzaBackofficeRequestParams, extraHttpRequestParams?: any): Observable<DocumentoAdminDTO>;

}
